var _style, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 217,
    viewBox: "0 0 248 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .calendar.path {\n    fill: var(--font-secondary);\n  }\n\n  .night .calendar.path {\n    fill: var(--font-secondary-night);\n  }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "calendar path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 0C16.1177 0 0 16.1178 0 36V181C0 200.882 16.1177 217 36 217H212C231.882 217 248 200.882 248 181V36C248 16.1178 231.882 0 212 0H36ZM41 52C28.2975 52 18 62.2975 18 75V174C18 186.703 28.2975 197 41 197H207C219.703 197 230 186.703 230 174V75C230 62.2975 219.703 52 207 52H41Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 85,
    cy: 82,
    r: 12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 201,
    cy: 82,
    r: 12
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 124,
    cy: 82,
    r: 12
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 163,
    cy: 82,
    r: 12
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 46,
    cy: 123,
    r: 12
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 85,
    cy: 123,
    r: 12
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 201,
    cy: 123,
    r: 12
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 124,
    cy: 123,
    r: 12
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 163,
    cy: 123,
    r: 12
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 46,
    cy: 164,
    r: 12
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 85,
    cy: 164,
    r: 12
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 124,
    cy: 164,
    r: 12
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "calendar path",
    cx: 163,
    cy: 164,
    r: 12
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.dc3f95aee8be1275591f0f7815c6505d.svg";
export { ForwardRef as ReactComponent };